import { useTranslation } from 'next-i18next';
import type { Locale } from 'date-fns';
import {
  es, fr, ja, pt, enUS,
} from 'date-fns/locale';

// `en` is not included, as it is part of `date-fns`.
const localeMap: Record<string, Locale> = {
  es,
  fr,
  ja,
  pt,
};

/**
 * Returns the `date-fns` `Locale` object required for localization of date formats.
 * @returns `date-fns` `Locale` object
 */
const useDateFnsLocale = (): Locale => {
  const { i18n } = useTranslation();
  return localeMap[i18n.language] ?? enUS;
};
export default useDateFnsLocale;
